/**
 * @fileoverview GET handler for the "/resources/productboard_auth" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { resourcesProductboardAuth } from "./constants";
import type { ResourcesProductboardAuthResult } from "./types";

export const getResourcesProductboardAuth = reactQueryFetcherAdapter(
  resourcesProductboardAuth,
  (signal: AbortSignal): Promise<ResourcesProductboardAuthResult> => {
    return fetch("/resources/productboard_auth", "GET", {}, { signal });
  }
);
